import { useTranslation } from "react-i18next"
import ChartLegend from "../../../../components/chart/ChartLegend"
import { DailyPriceChartResponsive } from "./DailyPriceChart"
import { HeaderContainer, PageContainer } from "../containers"
import { trpc } from "../../../../api/trpc/trpc"
import { ChartPlaceholder } from "../../../../components/placeholder/Placeholder.stories"
import { CalculationLabel } from "../CalculationLabel"
import { ChartLegendContainer } from "../ChartLegendContainer"

interface ContentProps {
  prices?: Map<number, number>
  isLoading: boolean
  isError: boolean
}

const DailyPriceContent = ({ isLoading, isError, prices }: ContentProps) => {
  const { t } = useTranslation("microsite")

  if (isLoading || !prices) {
    return (
      <PageContainer>
        <ChartPlaceholder />
      </PageContainer>
    )
  }

  const chartData: { marketPrice: number; hour: number }[] = []
  for (const [time, averagePrice] of prices) {
    chartData.push({
      marketPrice: averagePrice,
      hour: time,
    })
  }

  return (
    <PageContainer>
      <HeaderContainer>
        <CalculationLabel />
      </HeaderContainer>

      <DailyPriceChartResponsive isErrorState={isError} data={chartData} />

      <ChartLegendContainer>
        <ChartLegend items={[{ color: "primary", label: t("market_price") }]} />
      </ChartLegendContainer>
    </PageContainer>
  )
}

const DailyPrice = () => {
  const { isLoading, isError, data } = trpc.useQuery(["web.hourlyPrices"])

  return <DailyPriceContent isError={isError} isLoading={isLoading} prices={data} />
}

export default DailyPrice
